module.exports = __webpack_public_path__ + "img/LuckyHot7sFreeGames_EGM.381cc49f.jpg";